import React from 'react'
import Text from './components/atoms/Text/Text'
import { BrowserInfo } from './hooks/useAppInitProgress'
import { INVALID_BROWSER, INVALID_BROWSER_WITH_INFO } from './utils/client-constants'

const BrowserNotSupported = (props: BrowserInfo) => (
  <div className="h-screen flex flex-col items-center justify-center gap-4 p-4">
    <div className="text-center max-w-2xl">
      <h1 className="text-2xl font-bold mb-4" style={{ color: 'var(--tint-red-500)' }}>
        Browser Not Supported
      </h1>
      <Text className="text-black text-lg">
        {props.name && props.version ? INVALID_BROWSER_WITH_INFO(props) : INVALID_BROWSER}
      </Text>
    </div>
  </div>
)

export default BrowserNotSupported
